import { BehavioralInsightPresentationMode } from 'modules/domains/segmentation';
import { isNumberZero } from 'utils/numberHelpers';
import { maybeLocalizeInteger } from 'utils/i18nHelpers';
import { NumberInsightPanel } from './NumberInsightPanel';
import { useCustomBehavioralContext } from '../../../contexts/behaviorInsights/customBehavior';
import { useTranslation } from '../../../hooks';
import { InsightType } from '../../../types';

export const CustomInsights = () => {
  const { cachedCustomBehavioralInsights } = useCustomBehavioralContext();
  const { t } = useTranslation();

  return (
    <>
      {cachedCustomBehavioralInsights.map(({ event, behavior, mode, eventName }) => {
        const localizedValue = maybeLocalizeInteger(behavior?.value);
        const perUserValue = t('insights.showPerUser', { value: localizedValue });

        const value =
          mode === BehavioralInsightPresentationMode.TotalCount ? localizedValue : perUserValue;

        return (
          <NumberInsightPanel
            key={event}
            title={eventName}
            value={value}
            type={InsightType.behavioral}
            isZero={isNumberZero(behavior?.value)}
            isCustom
          />
        );
      })}
    </>
  );
};
